import { Casing } from 'src/app/models/filename-conventions/casing';
import { FilenameConvention } from 'src/app/models/filename-conventions/filename-convention';
import { FilenameConventionEvEntry } from 'src/app/models/filename-conventions/filename-convention-ev-entry';

export const conventionModeIcon = (convention: FilenameConvention): string =>
  convention.value.payload.mode === 'rangeBased' ? 'format_list_numbered' : 'tune';

export const conventionModeLabel = (convention: FilenameConvention): string =>
  convention.value.payload.mode === 'rangeBased' ? 'Range' : 'EV';

const uniqueMasterSuiteCount = (entries: readonly FilenameConventionEvEntry[]): number =>
  new Set(entries.map((e) => e.masterSuiteId)).size;

const totalPerSelectRowCount = (entries: readonly FilenameConventionEvEntry[]): number =>
  entries.reduce((sum, e) => sum + e.selects.length, 0);

export interface ConventionSummary {
  entryCount: number;
  masterSuiteCount: number;
  selectRowCount: number;
}

export const conventionSummary = (convention: FilenameConvention): ConventionSummary => {
  const payload = convention.value.payload;
  if (payload.mode === 'rangeBased') {
    return {
      entryCount: payload.entries.length,
      masterSuiteCount: 0,
      selectRowCount: 0,
    };
  }
  return {
    entryCount: payload.entries.length,
    masterSuiteCount: uniqueMasterSuiteCount(payload.entries),
    selectRowCount: totalPerSelectRowCount(payload.entries),
  };
};

export const rangeEntriesLabel = (count: number): string =>
  count === 1 ? '1 entry' : `${count} entries`;

export const evEntriesLabel = (count: number): string => (count === 1 ? '1 EV' : `${count} EVs`);

export const evMasterSuiteLabel = (count: number): string => (count === 1 ? '1 MS' : `${count} MS`);

const CASING_LONG_LABELS: Record<Casing, string> = {
  Match: 'Casing as is',
  Upper: 'All uppercase',
  Lower: 'All lowercase',
};

export const casingLongLabel = (casing: Casing): string => CASING_LONG_LABELS[casing];

export const firstRangeEntryCasingLabel = (convention: FilenameConvention): string => {
  const payload = convention.value.payload;
  if (payload.mode !== 'rangeBased') return '';
  const first = payload.entries[0];
  if (first === undefined) return '';
  return casingLongLabel(first.casing);
};
